// date-fns format tokens, kept apart from the catalog so code that needs only
// these (tests/unit/helpers/mountReal.js) doesn't load all ~3,600 lines of it.
// Unit-test selection in CI keys on which modules each spec loads, so an
// edit to any catalog string would otherwise rerun every mountReal spec.
export default {
  "date-event": "yyyy-MM-dd",
  "date-time-event": "yyyy-MM-dd HH:mm",
  "date-standard": "yyyy/MM/dd",
  "date-time-standard": "yyyy/MM/dd HH:mm",
  "date-short": "E, M/d/yyyy",
  "date-time-short": "E, M/d/yyyy–h:mma",
  "date-full": "E, MMM d, yyyy",
  "date-long": "MMMM d, yyyy",
  "date-time-full": "E, MMM d, yyyy–h:mma",
  "time-short": "h:mma",
  "time-standard": "HH:mm",
};
